import React, { useContext, useState } from 'react';
import {
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  Button,
  SearchContext,
  PaginationContext,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';
import SaveOrganizationModal from 'pages/organizations/OrganizationDetailsPage/components/SaveOrganizationDetailsModal/SaveOrganizationDetailsModal';

function OrganizationsTableHeader() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation('tables', { keyPrefix: 'organizations' });
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const { setSearchSlug } = useContext(SearchContext);
  const { resetPagination } = useContext(PaginationContext);
  const [search, setSearch] = useState('');

  return (
    <>
      <Flex
        w="100%"
        px={6}
        py={4}
        justifyContent="space-between"
        flexDirection="row"
        flex={1}
      >
        <Flex flex={1} flexDirection="row">
          <InputSearch
            w="100%"
            css={'height: 40px'}
            onClear={() => {
              setSearch('');
              setSearchSlug('');
              resetPagination();
            }}
            value={search}
            placeholder={t`searchInputPlaceholder` || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              resetPagination();
              setSearch(event.target.value);
              setSearchSlug(event.target.value);
            }}
          />
        </Flex>
        <Flex>
          <PaginationPerPageSelect label={`${tLabels`show`} `} w={130} mx={4} />
          <Button
            icon="plus"
            px={5.5}
            onClick={() => setIsModalOpen(true)}
          >{t`addNewButtonLabel`}</Button>
        </Flex>
      </Flex>
      <SaveOrganizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

export default OrganizationsTableHeader;
